// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-53791e68]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.fee-template .nav-bar[data-v-53791e68] {\n  padding: 15px;\n  margin-bottom: 10px;\n  border-radius: 3px;\n}\n.fee-template .wrap[data-v-53791e68] {\n  padding: 15px;\n  border-radius: 3px;\n}", ""]);
// Exports
module.exports = exports;
